import { useColorMode } from '@chakra-ui/react';

import { useFeatureFlag } from '@bonusly/who-am-i';

/**
 * Hook to access dark mode state
 *
 * Returns the current color mode and whether dark mode is enabled
 * Note: Users can only toggle dark mode if they have the 'dark-mode-beta' feature flag,
 * but isDarkMode reflects the actual color mode state regardless of feature flag to ensure
 * consistency with HTML-applied dark mode styling.
 */
export const useDarkMode = () => {
	const hasFeatureFlag = useFeatureFlag('dark-mode-beta');
	const { colorMode, toggleColorMode } = useColorMode();

	return {
		/** Current color mode ('light' | 'dark') */
		colorMode,
		/** True if currently in dark mode (reflects actual color mode state, not gated by feature flag) */
		isDarkMode: colorMode === 'dark',
		/** True if user has the feature flag to toggle dark mode */
		canToggleDarkMode: hasFeatureFlag,
		/** Function to toggle between light and dark mode */
		toggleDarkMode: toggleColorMode,
	};
};
